<template>
  <v-card ref="fsRoot" id="projection-tamto-yesterday" elevation="0" :class="{ 'fullscreen-mode': isFullscreen }" class="projection">
    <v-card-text class="projection__body">
      <v-row align="center" no-gutters class="mb-2 projection__topbar">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="extenderPantalla">
          <v-icon left>{{ fsIcon }}</v-icon>
          {{ fsLabel }}
        </v-btn>
      </v-row>

      <v-tabs-items v-model="tab" class="projection__tabs">
        <v-tab-item value="tab-1" class="projection__tab-item">
          <ReporteEficienciaOperadoresCarrusel
            :update="tiempoActualizacion"
            rango-inicial="diaAnterior"
          />
        </v-tab-item>

        <v-tab-item value="tab-2" class="projection__tab-item">
          <ReporteOEEFechasCarrusel
            :update="tiempoActualizacion"
            rango-inicial="diaAnterior"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import ReporteEficienciaOperadoresCarrusel from "./Proyeccion/ReporteEficienciaOperadoresCarrusel.vue";
import ReporteOEEFechasCarrusel from "./Proyeccion/ReporteOEEFechasCarrusel.vue";

export default {
  components: {
    ReporteEficienciaOperadoresCarrusel,
    ReporteOEEFechasCarrusel,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      interval: null,
      pos: 1,
      tiempoActualizacion: 1,
      isFullscreen: false,
    };
  },
  computed: {
    tab() {
      return `tab-${this.pos}`;
    },
    fsLabel() {
      return this.isFullscreen ? "Salir de Pantalla Completa" : "Pantalla Completa";
    },
    fsIcon() {
      return this.isFullscreen ? "mdi-arrow-collapse-all" : "mdi-arrow-expand-all";
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.pos = this.pos === 2 ? 1 : this.pos + 1;
    }, 62 * 1000);

    const sync = () => {
      this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", sync);
    document.addEventListener("webkitfullscreenchange", sync);
    document.addEventListener("MSFullscreenChange", sync);
    this._syncFs = sync;
  },
  beforeDestroy() {
    clearInterval(this.interval);

    if (this._syncFs) {
      document.removeEventListener("fullscreenchange", this._syncFs);
      document.removeEventListener("webkitfullscreenchange", this._syncFs);
      document.removeEventListener("MSFullscreenChange", this._syncFs);
    }
  },
  methods: {
    async extenderPantalla() {
      const ref = this.$refs.fsRoot;
      const el = ref?.$el || ref;
      if (!el) return;

      const isFs = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );

      try {
        if (!isFs) {
          await this._enterFullscreen(el);
        } else {
          await this._exitFullscreen();
        }
      } finally {
        this.isFullscreen = !!(
          document.fullscreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
        );
      }
    },
    async _enterFullscreen(el) {
      if (el.requestFullscreen) return el.requestFullscreen();
      if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
      if (el.msRequestFullscreen) return el.msRequestFullscreen();
      this.$toast && this.$toast.error?.("Pantalla completa no soportada en este navegador");
    },
    async _exitFullscreen() {
      const anyDoc = document;
      if (document.exitFullscreen) return document.exitFullscreen();
      if (anyDoc.webkitExitFullscreen) return anyDoc.webkitExitFullscreen();
      if (anyDoc.msExitFullscreen) return anyDoc.msExitFullscreen();
    },
  },
};
</script>

<style scoped>
.projection {
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.projection__body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.projection__topbar {
  flex: 0 0 auto;
}

.projection__tabs,
.projection__tab-item {
  height: 100%;
  min-height: 0;
}

.projection__tab-item >>> .v-window-item__content {
  height: 100%;
  min-height: 0;
}

.fullscreen-mode {
  width: 100vw !important;
  height: 100vh !important;
}
</style>
